interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon = "ri-inbox-line",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg border border-dashed border-background-300 bg-background-100/60">
      <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-4">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-600 max-w-sm leading-6">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}